import React, {useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../components/me-child-header'
import MeLoading from '../../components/loading'
import { Formik, Form, Field } from "formik";
import { BigButton } from '../../../../components/button'
import { useIntl } from 'react-intl'
import { changePassword } from '../../../../../api'
import Toast from '../../../../components/toast'
import { isEmojiCharacter } from '../../../../../utils/common'

const ChangePasswordForm = props => {
    useStyles(classes)

    const { onSubmit, Intl } = props

    return (
        <div className={classes.ChangePasswordForm}>
            <Formik
                onSubmit={(e) => onSubmit(e)}
                initialValues={{
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: '',
                }}
                validate={values => {
                    const errors = {}

                    if(!values?.oldPassword){
                        errors.oldPassword = Intl.formatMessage({id: 'fill_in_password'})
                    }

                    if(!values?.newPassword){
                        errors.newPassword = Intl.formatMessage({id: 'fill_in_password'})
                    } else if(values?.newPassword?.length < 6){
                        errors.newPassword = Intl.formatMessage({id:"six_characters_min", defaultMessage:"6 characters minimum"});
                    } else if(values?.newPassword?.length > 20){
                        errors.newPassword = Intl.formatMessage({id:"twenty_characters_max", defaultMessage:"20 characters maximum"})
                    } else if(isEmojiCharacter(values?.newPassword)){
                        errors.newPassword = Intl.formatMessage({id:"no_emojis", defaultMessage:"No emojis"});
                    } else if( values?.newPassword == values?.oldPassword){
                        errors.newPassword = Intl.formatMessage({id:'old_new_password'}) + '!'
                    }

                    if(!values?.confirmPassword){
                        errors.confirmPassword = Intl.formatMessage({id: 'fill_in_password'})
                    } else if (values?.confirmPassword !== values?.newPassword){
                        errors.confirmPassword = Intl.formatMessage({id: 'must_new_password'}) + '!'
                    }

                    return errors
                }}
            >
                {
                    ({errors, touched}) =>(

                        <Form>
                            <div className={classes.FormItem}>
                                <label htmlFor="oldPasswordInput">{Intl.formatMessage({id: 'current_password'})}</label>
                                <Field name="oldPassword">
                                    {({field, form: {touched, errors}, meta}) => (
                                        <div>
                                            <input id="oldPasswordInput" type="text" className={`${meta.touched && meta.error ? classes.ErrorInput: ''}`} {...field}/>
                                            {
                                                meta.touched && meta.error && (
                                                    <div className={classes.Errors}>{meta.error}</div>
                                                )
                                            }
                                        </div>
                                    )}
                                </Field>
                            </div>

                            <div className={classes.FormItem}>
                                <label htmlFor="newPasswordInput">{Intl.formatMessage({id: 'new_password'})}</label>
                                <Field name="newPassword">
                                    {({field, form: {touched, errors}, meta}) => (
                                        <div>
                                            <input id="newPasswordInput" type="text" className={`${meta.touched && meta.error ? classes.ErrorInput: ''}`} {...field}/>
                                            {
                                                meta.touched && meta.error && (
                                                    <div className={classes.Errors}>{meta.error}</div>
                                                )
                                            }
                                        </div>
                                    )}
                                </Field>
                            </div>

                            <div className={classes.FormItem}>
                                <label htmlFor="confirmPasswordInput">{Intl.formatMessage({id: 'confirm_pwd'})}</label>
                                <Field name="confirmPassword">
                                    {({field, form: {touched, errors}, meta}) => (
                                        <div>
                                            <input id="confirmPasswordInput" type="text" className={`${meta.touched && meta.error ? classes.ErrorInput: ''}`} {...field}/>
                                            {
                                                meta.touched && meta.error && (
                                                    <div className={classes.Errors}>{meta.error}</div>
                                                )
                                            }
                                        </div>
                                    )}
                                </Field>
                            </div>

                            <div className={classes.SignOutButton}>
                                <BigButton type="submit">{Intl.formatMessage({id:'save', defaultMessage:'save'})}</BigButton>
                            </div>
                        </Form>)
                }
            </Formik>
        </div>
    )
}


const ChangePassword = props => {
    useStyles(classes)

    const [loading, setLoading] = useState(false)
    const Intl = useIntl()

    const onBack = () => {
        window.history.back()
    }

    const changePasswordFunc = (e) => {
        setLoading(true)
        let headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        if(e?.currentPassword && !e?.oldPassword){
            e.oldPassword = e.currentPassword
        }
        changePassword(e, headers).then(res => {
            setLoading(false)
            if(res?.code == 200){
                Toast(Intl.formatMessage({id: 'change_successful', defaultMessage: 'Change SuccessFul!'}))
                setTimeout(() => {
                    onBack()
                },3000)
            } else {
                alert(res?.result || Intl.formatMessage({id: 'change_failed', defaultMessage: 'Change Failed!'}))
            }
        }).catch(err => {
            setLoading(false)
            alert(err?.result || err || Intl.formatMessage({id: 'change_failed', defaultMessage: 'Change Failed!'}))
        })
    }

    return <div className={classes.ChangePasswordPage}>
        <MeChildHeader name={Intl.formatMessage({id:'change_password', defaultMessage:'Change Password'})} onBack={() => onBack()}/>

        <ChangePasswordForm loading={loading} onSubmit={ (e) => changePasswordFunc(e)} Intl={Intl}/>

        <MeLoading loading={loading} />
    </div>
}

ChangePassword.fetchData = async (store, params, search, headers) => {
    // await store.dispatch(action_get_credit_cards(headers))
}

export default ChangePassword